import { Reducer } from '@reduxjs/toolkit';
import update from 'immutability-helper';
import typeToReducer from 'type-to-reducer';
import { PublistaAction } from '../infrastructure/commonTypes';
import {
  supportInitialState,
  SupportInitialStateTypes,
} from '../store/initialState';
import { parseAxiosError } from '../utils/axiosResponseHelper';

export const supportReducer: Reducer<SupportInitialStateTypes, PublistaAction> =
  typeToReducer<SupportInitialStateTypes, PublistaAction>(
    {
      PROVINCES_GET: {
        PENDING: (state: SupportInitialStateTypes) =>
          update(state, {
            provinces: {
              fetching: { $set: true },
            },
          }),
        REJECTED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            provinces: {
              fetching: { $set: false },
              fetched: { $set: false },
              error: { $set: parseAxiosError(payload) },
            },
          });
        },
        FULFILLED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            provinces: {
              fetching: { $set: false },
              fetched: { $set: true },
              data: { $set: payload.data },
              error: { $set: null },
            },
          });
        },
      },
      REGIONS_GET: {
        PENDING: (state: SupportInitialStateTypes) =>
          update(state, {
            regions: {
              fetching: { $set: true },
            },
          }),
        REJECTED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            regions: {
              fetching: { $set: false },
              fetched: { $set: false },
              error: { $set: parseAxiosError(payload) },
            },
          });
        },
        FULFILLED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            regions: {
              fetching: { $set: false },
              fetched: { $set: true },
              data: { $set: payload.data },
              error: { $set: null },
            },
          });
        },
      },
      SITE_FORMATS_GET: {
        PENDING: (state: SupportInitialStateTypes) =>
          update(state, {
            siteFormats: {
              fetching: { $set: true },
            },
          }),
        REJECTED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            siteFormats: {
              fetching: { $set: false },
              fetched: { $set: false },
              error: { $set: parseAxiosError(payload) },
            },
          });
        },
        FULFILLED: (state: SupportInitialStateTypes, action: any) => {
          const payload = action?.payload;

          return update(state, {
            siteFormats: {
              fetching: { $set: false },
              fetched: { $set: true },
              data: { $set: payload.data },
              error: { $set: null },
            },
          });
        },
      },
      PARTNER_GET: {
        PENDING: (state) =>
          update(state, {
            partner: {
              fetching: { $set: true },
            },
          }),
        REJECTED: (state, action) => {
          const payload = action?.payload;

          return update(state, {
            partner: {
              fetching: { $set: false },
              fetched: { $set: false },
              error: { $set: parseAxiosError(payload) },
            },
          });
        },
        FULFILLED: (state, action) => {
          const payload = action?.payload;

          return update(state, {
            partner: {
              fetching: { $set: false },
              fetched: { $set: true },
              data: { $merge: payload.data },
              error: { $set: null },
            },
          });
        },
      },
    },
    supportInitialState
  );
